/* @flow */

import { makeListLink } from './utils';

export default makeListLink({ pathname: '/mbs', children: 'mbs' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/MBSLink.js